import { Button } from "@/components/buttons";
import { useClientAreasDataProvider } from "./client-areas.data-loader";
import { PageContainer, PageHeader } from "@/components/page";
import { useAuth0 } from "@auth0/auth0-react";
import { useTranslation } from "react-i18next";

const ClientAreasValidator = ({ children }: { children: React.ReactNode }) => {
  const { areas } = useClientAreasDataProvider();
  const { logout } = useAuth0();
  const { t } = useTranslation();

  if (!areas || !areas.length) {
    return (
      <PageContainer>
        <PageHeader>Aucune parcelle trouvée</PageHeader>
        <div tw="flex flex-col items-center justify-center h-full">
          <p tw="text-gray-500">Vous n'avez pas encore de parcelle protégée.</p>
          <div tw="py-2">
            <Button
              red
              onClick={() =>
                logout({ logoutParams: { returnTo: window.location.origin } })
              }
              tw="w-fit"
            >
              {t("action.logOut")}
            </Button>
          </div>
        </div>
      </PageContainer>
    );
  }

  return children;
};

export default ClientAreasValidator;
